// ANANT CITYPRO — Merchant Leaderboard (monthly public)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { fmtDateHuman } from '../../utils/dateFmt';

export default function CityProLeaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [periodStart, setPeriodStart] = useState('');
  useEffect(() => {
    api.get('/citypro/leaderboard', { params: { limit: 30 } })
      .then((r) => { setRows(r.data?.leaderboard || []); setPeriodStart(r.data?.period_start || ''); })
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-b from-amber-950 via-slate-950 to-fuchsia-950 text-white" data-testid="cp-leaderboard">
      <div className="max-w-4xl mx-auto px-3 pb-16">
        <div className="flex items-center gap-2 mb-3">
          <Link to="/citypro" className="text-xs text-slate-400 hover:text-white">← Back to CityPro</Link>
        </div>
        <h1 className="text-2xl sm:text-3xl font-black tracking-tight">🏆 Merchant Leaderboard</h1>
        <p className="text-[11px] opacity-70 mb-3">Monthly · top boosted + top earning · updated live · badges awarded</p>
        {periodStart && <div className="text-[10px] opacity-60 mb-3">Period start: {fmtDateHuman(periodStart)}</div>}
        {loading && <div className="text-center opacity-70 py-8">⏳ Loading…</div>}
        <div className="space-y-1.5">
          {rows.map((m, i) => (
            <Link key={m.user_id} to="/citypro/showcase" data-testid={`cp-lb-${i}`}
                  className={`flex items-center gap-3 rounded-2xl border-2 p-3 transition ${i < 3 ? 'border-amber-400 bg-gradient-to-r from-amber-900/40 to-slate-900' : 'border-slate-700 bg-slate-900/70 hover:border-fuchsia-400'}`}>
              <div className="w-10 text-center text-2xl">{m.badge}</div>
              <div className="w-8 text-center text-xs opacity-70 font-black">#{i + 1}</div>
              {m.front_image_url && <div className="w-12 h-12 rounded-lg bg-slate-800 bg-cover bg-center shrink-0" style={{ backgroundImage: `url(${m.front_image_url})` }} />}
              <div className="flex-1 min-w-0">
                <div className="text-sm font-black truncate">{m.shop_name || `@${m.username}`}</div>
                <div className="text-[10px] opacity-70 truncate">{m.city || 'city n/a'} · {m.merchant_category || 'general'}</div>
                <div className="text-[10px] opacity-80 flex gap-2 flex-wrap mt-0.5">
                  <span>💰 Earn: <b className="text-emerald-300">{m.month_earnings_at} AT</b></span>
                  <span>🚀 Boost: <b className="text-orange-300">{m.boost_score || 0}</b></span>
                  <span>📦 Orders: <b>{m.month_orders}</b></span>
                </div>
              </div>
              <div className="text-lg font-black text-amber-200">{m.score}</div>
            </Link>
          ))}
          {!loading && rows.length === 0 && <div className="text-center opacity-60 py-8 text-sm">No merchants yet · come back after some orders complete</div>}
        </div>
      </div>
    </div>
  );
}
